<template>
    <div class="clipperWrapper" v-if="openClipper" @click="closeClipper">
        <div class="clipperContent" :class="{ clipperActive: openClipper }" @click.stop="nothings">
            <!-- 顶部操作模块 -->
            <figure class="clipperOpration">
                <figcaption class="icon iconfont icon-clear" @click="closeClipper"></figcaption>
            </figure>

            <!-- 颜色选择模块 -->
            <figure class="bgColorWrap">
                <p>背景颜色</p>
                <figcaption class="colorCardList">
                    <div class="colorItem" v-for="(item, index) in bgColorList" :key="index" :style="{ background: item }"
                        :class="{ 'colorActive': chooseColor == item }" @click="chooseActiveColor(item)"></div>
                </figcaption>
            </figure>

            <!-- 尺寸选择模块 -->
            <figure class="sizeWrap">
                <p>照片尺寸</p>
                <figcaption class="sizeList">
                    <div class="sizeItem" v-for="(item, index) in sizeList" :key="index"
                        :class="{ 'sizeActive': chooseSizeIndex == index }" @click="selectSize(item, index)">{{ item.label
                        }}</div>
                </figcaption>
            </figure>


            <!-- 图片选择 -->
            <figure class="chooseImageWrap">
                <p>图片选择</p>
                <input type="file" accept=".png, .jpg, .jpeg" @change="chooseImgFile" placeholder="xxx">
            </figure>

            <div class="oprationGroups">
                <div class="cropper" style="text-align:center">
                    <p>图片裁剪<span>滑动滚轮可放大/缩小图片</span></p>
                    <!-- :autoCropWidth="option.autoCropWidth" 
                        :autoCropHeight="option.autoCropHeight" -->
                    <vueCropper ref="cropper" :img="option.img" :outputSize="option.size" :outputType="option.outputType"
                        :info="option.info" :full="option.full" :canMove="option.canMove" :canMoveBox="option.canMoveBox"
                        :original="option.original" :autoCrop="option.autoCrop" :fixed="option.fixed"
                        :fixedNumber="option.fixedNumber" :centerBox="option.centerBox" :infoTrue="option.infoTrue"
                        :fixedBox="option.fixedBox" @realTime="realTime"></vueCropper>
                </div>

                <div class="outPutWrap" v-if="outPutImgUrl">
                    <p>输出图片 </p>
                    <div class="ouputImagesWrapper"
                        :style="{ width: option.autoCropWidth + 'px', height: option.autoCropHeight + 'px', background: chooseColor }">
                        <img v-if="outPutImgUrl" :src="outPutImgUrl">

                        <!-- 辅助线 -->
                        <div class="subline" v-if="showSubline"></div>
                    </div>
                    <div class="saveImages" @click="saveOutPutFile">保存图片 </div>
                </div>

            </div>

        </div>
    </div>
</template> 
<script>
import html2canvas from 'html2canvas';
export default {
    props: {},
    data() {
        return {
            openClipper: false,//是否打开照片裁剪模块 默认false
            bgColorList: ['white', 'blue', 'red', 'gray'], //背景颜色组
            sizeList: [
                { label: '二寸', widths: 3.5, heights: 4.5, sizeId: 1 },
                { label: '大二寸', widths: 3.3, heights: 4.8, sizeId: 2 },
                { label: '美国', widths: 5, heights: 5, sizeId: 3 }
            ], //尺寸选择数据
            chooseColor: 'blue', //选择的颜色
            chooseSizeIndex: 0,
            option: {
                img: '',                // 裁剪图片的地址
                info: true,             // 裁剪框的大小信息
                outputSize: 1,        // 裁剪生成图片的质量
                outputType: 'png',     // 裁剪生成图片的格式
                canScale: true,        // 图片是否允许滚轮缩放
                autoCrop: true,         // 是否默认生成截图框
                autoCropWidth: 0,  // 默认生成截图框宽度
                autoCropHeight: 0, // 默认生成截图框高度
                fixedBox: false,        // 固定截图框大小不允许改变
                // fixed: false,           // 是否开启截图框宽高固定比例
                // fixedNumber: [1, 1],    // 截图框的宽高比例
                full: false,             // 是否输出原图比例的截图
                canMoveBox: true,       // 截图框能否拖动
                original: false,        // 上传图片按照原始比例渲染
                centerBox: false,        // 截图框是否被限制在图片里面
                infoTrue: false,          // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
            },
            outPutImgUrl: '', //输出的图片URL
            createImgTimmer: null,//输出图片定时器
            showSubline: true,//是否显示辅助线 默认 true， 截图时隐藏
        }
    },
    created() {
        let _this = this;
        const currentSizeInfo = _this.sizeList[_this.chooseSizeIndex];
        const width = currentSizeInfo.widths * 50;
        const height = currentSizeInfo.heights * 50;
        _this.option.autoCropWidth = width;
        _this.option.autoCropHeight = height;
    },
    methods: {
        nothings() { },
        // 初始化
        initClipper() {
            let _this = this;
            _this.outPutImgUrl = '';
            _this.chooseColor = 'white';
            _this.option.img = '';
            _this.chooseSizeIndex = 0;
        },
        // 关闭弹窗
        closeClipper() {
            this.openClipper = false;
            this.initClipper();
        },
        // 打开弹窗
        openWrap() {
            this.openClipper = true;
        },
        // 选择颜色
        chooseActiveColor(item) {
            this.chooseColor = item;
        },
        // 选择尺寸
        selectSize(item, index) {
            let _this = this;
            _this.chooseSizeIndex = index;

            const currentSizeInfo = _this.sizeList[index];
            const width = currentSizeInfo.widths * 50;
            const height = currentSizeInfo.heights * 50;

            _this.option.autoCropWidth = width;
            _this.option.autoCropHeight = height;

            this.$refs.cropper.goAutoCrop()
        },
        // 文件选择
        chooseImgFile(e) {
            let _this = this;
            const targetFile = e.target.files[0];
            _this.getBase64(targetFile).then((res) => {
                _this.option.img = res;
            })
        },
        // 输出图片
        realTime(data) {
            let _this = this;
            if (_this.createImgTimmer) {
                clearTimeout(_this.createImgTimmer);
                _this.createImgTimmer = null;
            }
            _this.createImgTimmer = setTimeout(() => {
                _this.$refs.cropper.getCropData((data) => {
                    _this.outPutImgUrl = data;
                })
            }, 300);
        },
        async fakeAsync(timeouts = 200) {
            return new Promise((resolve) => {
                setTimeout(() => {
                    resolve()
                }, timeouts);
            })
        },
        // 保存
        saveOutPutFile() {
            let _this = this;
            // var myBlob = _this.dataURLtoBlob(_this.outPutImgUrl);
            // var myUrl = URL.createObjectURL(myBlob);
            // _this.downloadFile(myUrl, '头像.png');

            _this.showSubline = false;
            _this.fakeAsync(5000).then(() => {
                let aimPart = document.querySelector('.ouputImagesWrapper');

                html2canvas(aimPart, {
                    scale: 2,
                    width: aimPart.offsetWidth,
                    height: aimPart.offsetHeight,
                    allowTaint: true,    // 允许污染画布
                    proxy: '/imgProxy'
                }).then((canvas) => {
                    let imgUrl = canvas.toDataURL('image/png', 1);

                    let downLoadLink = document.createElement('a');
                    downLoadLink.innerText = '下载'
                    downLoadLink.download = '头像.png';
                    downLoadLink.href = imgUrl;
                    downLoadLink.className = "downLoadLink"
                    downLoadLink.style.display = "none";

                    // 下载图片
                    aimPart.appendChild(downLoadLink)
                    window.setTimeout(() => {
                        document.querySelector('.downLoadLink').dispatchEvent(new MouseEvent('click'));
                        aimPart.removeChild(document.querySelector('.downLoadLink'));
                        _this.showSubline = true;

                    }, 500)

                })

            })


        },
        dataURLtoBlob(dataurl) {
            var arr = dataurl.split(","),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], { type: mime });
        },
        downloadFile(url, name = "What's the fuvk") {
            var a = document.createElement("a");
            a.setAttribute("href", url);
            a.setAttribute("download", name);
            a.setAttribute("target", "_blank");
            let clickEvent = document.createEvent("MouseEvents");
            clickEvent.initEvent("click", true, true);
            a.dispatchEvent(clickEvent);
            this.$message.success('图片已保存！')

        },
        getBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = (error) => reject(error);
            });
        }

    }
}
</script>
  
<style scoped src="./index.css"></style>